export const extractDomain = () => {
    const domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
    if (domain !== "members.tripmerchant.com") {
        const parts = domain.split(".");
        const subDomain = parts[0] === "www" ? parts[1] : parts[0];
        if (subDomain && subDomain !== "tripmerchant" && subDomain !== "localhost:3001") {
            return subDomain;
        }
    }
    return "trip"; // Default domain
};
